import React from "react";

const MasterStatsTable = ({ events, selectedEvent, handleRowClick }) => {
    return (
        <>
            <h4 className="mt-4 mb-2">Συνολικά Στατιστικά Seasonal Events</h4>
            <div className="table-responsive">
                <table className="table table-bordered table-hover">
                    <thead className="table-light">
                        <tr>
                            <th>Κωδικός Event</th>
                            <th>Όνομα Event</th>
                            <th>Αριθμός Μεταβιβάσεων</th>
                        </tr>
                    </thead>
                    <tbody>
                        {events.length > 0 ? (
                            events.map((event) => (
                                <tr 
                                    key={event.eventCode} 
                                    onClick={() => handleRowClick(event)}
                                    className={selectedEvent?.eventCode === event.eventCode ? "table-primary" : ""}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <td>{event.eventCode}</td>
                                    <td>{event.eventName}</td>
                                    <td>{event.totalSeasonTransfers}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="3" className="text-center">Δεν βρέθηκαν seasonal events.</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </>
    );
};

export default MasterStatsTable;
